import React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { ColorBoxFilter } from '../components/color-box-filter/ColorBoxFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';
import st from '../shared.module.sass';

export const LowerCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const [color, type] = useWatch({ name: ['lower_garment_types', 'lower_garment_colors'] });
  const filterCount = [color, type]
    .filter((arr) => Array.isArray(arr) && arr.length > 0).length > 0
    ? 1 : 0;
  useFilterCount('lower', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="lowerFilter"
      triggerValue={t('events:карточка.низ')}
      {...props}
    >
      <ColorBoxFilter
        control={control}
        isMulti
        label={t('events:bottom_colors')}
        name="lower_garment_colors"
        options={EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.COLORS.raw}
      />

      <Divider small />
      <div className={st.Divider} />
      <Divider small />

      <CheckboxCustomFilter
        control={control}
        isMulti
        label={t('events:bottom_type')}
        name="lower_garment_types"
        options={EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.TYPE.raw}
      />
    </CustomFilterPopover>
  );
};
